import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { loginPage } from '@/constants/loginPage';

export function WelcomeSection() {
  const { t } = useTranslation('entity-portal');

  return (
    <Stack spacing={1.5} alignItems="center" textAlign="center" sx={{ width: '100%' }}>
      <Typography
        id="login-page-title"
        component="h1"
        variant="h3"
        sx={{
          color: loginPage.headingColor,
          typography: { xs: 'h3', sm: 'h3' },
          m: 0,
        }}
      >
        {t('login.loginPageTitle')}
      </Typography>
      <Typography
        component="p"
        variant="body1"
        sx={{
          color: loginPage.subtitleColor,
          maxWidth: 360,
          m: 0,
        }}
      >
        {t('login.loginPageSubtitle')}
      </Typography>
    </Stack>
  );
}
